import { ParameterTypeSelector } from "../ParameterTypeSelector";

import { BuilderContent } from "./BuilderContent";
import { Controls } from "./Controls";

import { ParametersPreviewSidebar } from "../ParametersPreviewSidebar";

export const ParameterBuilderDialog = ({
  setIsOpen,
  setIsOpenConfirmDialog,
}: {
  setIsOpen: (isOpen: boolean) => void;
  setIsOpenConfirmDialog: (isOpen: boolean) => void;
}) => {
  return (
    <div className="flex w-full gap-6">
      <div className="flex w-[60%] flex-col gap-4 border-r pr-4">
        <h1 className="text-lg font-medium">Add a new parameter</h1>
        <div className="flex flex-col gap-4">
          <div className="flex h-full max-h-[700px] flex-col gap-4 overflow-y-auto transition-[max-height] duration-300 ease-in-out max-h-1120:max-h-[550px] max-h-952:max-h-[450px] max-h-800:max-h-[350px]">
            <ParameterTypeSelector />
            <BuilderContent />
          </div>
          <div className="mt-4 flex gap-2">
            <Controls
              setIsOpen={setIsOpen}
              setIsOpenConfirmDialog={setIsOpenConfirmDialog}
            />
          </div>
        </div>
      </div>
      <div className="flex w-[40%] flex-col">
        <ParametersPreviewSidebar />
      </div>
    </div>
  );
};
